module.exports = __webpack_public_path__ + "img/spine.5f5385b6.jpg";